import { render, staticRenderFns } from "./ResourceDashboard.vue?vue&type=template&id=397d6744&scoped=true"
import script from "./ResourceDashboard.vue?vue&type=script&lang=js"
export * from "./ResourceDashboard.vue?vue&type=script&lang=js"
import style0 from "./ResourceDashboard.vue?vue&type=style&index=0&id=397d6744&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d6744",
  null
  
)

export default component.exports